import script from "./UnassignedBankTransaction.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnassignedBankTransaction.vue?vue&type=script&setup=true&lang=ts"

import "./UnassignedBankTransaction.vue?vue&type=style&index=0&id=1989247f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1989247f"]])

export default __exports__